module.exports = __webpack_public_path__ + "img/yiwen.03c5b466.png";